export default "__VITE_ASSET__0bdd8822__"